@import '../../../node_modules/flickity/css/flickity.css';

:host {
  display: block;
  --asplayer-btn-color: #FE5771;
  --asplayer-btn-txt-color: #fff;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  height: calc(100%);
  width: 100%;
  max-width: 480px;
  position: absolute;
  left:0px;
  bottom:0px;
  right:0px;
  margin: auto;
  font-family: inherit !important;
  --as-font-family: 'Helvetica Neue','Segoe UI',Helvetica,Arial,sans-serif;
}

.overlay {
  /* font-family: var(--as-font-family); */
  width: 100%;
  height: 0;
  position: absolute;
  bottom: 0;
  z-index: 2147483647;
  background-color: #131313;
  overflow-y: hidden;
  transition: 0.5s;
  color: #fff;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  height: 0%;
  overflow-x: hidden;
  --as-product-header-border-color: #949494;
  --as-product-border-color: #5F5E5E;
  --as-product-border-color-separator: #5F5E5E;
  --as-product-images-selected-dot-color: #fff;
  --as-product-images-dot-color: #949494;
  --as-product-options-disabled-color: #949494;
  --as-product-options-background: #575656;
  --as-product-section-heading-color: #DDDDDD;
  --as-product-options-border: #B5B5B5;
  --as-product-read-more-color: #B5B5B5;
  --as-discount-color: #17ff11;
  --as-error-color: #cf6679;
}

@media(min-width: 576px) {
  .overlay {
    /* left: 50%;
    transform: translate(-50%, 0); */
    max-width: 480px;
  }
}

.backdrop {
  transition: 0s;
  height: 100%;
  background-color: rgba(18, 18, 18, 0.75);
  cursor: pointer;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.backdrop.darkBackdrop {
  background-color: rgba(18, 18, 18, 0.4);
}

.overlay.light {
  background-color: #fff;
  color: #121212;
  border: none;
  --as-product-header-border-color: #cdcdcd;
  --as-product-border-color: #B5B5B5;
  --as-product-border-color-separator: #E9E8E8;
  --as-product-images-selected-dot-color: #575656;
  --as-product-images-dot-color: #CDCDCD;
  --as-product-options-background: #EDEDED;
  --as-product-options-disabled-color: #CDCDCD;
  --as-product-section-heading-color: #424242;
  --as-product-options-border: #CDCDCD;
  --as-product-read-more-color: #949494;
  --as-discount-color: #198F16;
  --as-error-color: #D02702;
}

.overlay .product-content {
  position: relative;
}

.overlayopen{
  height: 85vh;
  height: calc(var(--vh, 1vh) * 85);
  max-height: 620px;
  transition: 0.25s;
}

.closebtn{
 cursor: pointer;
}

.overlay .header {
  padding: 16px 16px 12px 16px;
  position: absolute;
  top: 0;
  width: 100%;
  margin-bottom: 4px;
  border-bottom: 1px solid var(--as-product-header-border-color);
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.header .product-card {
  display: flex;
  width: 100%;
  height: 56px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  box-sizing: border-box;
}
.header .product-card img.product {
  width: 56px;
  height: 56px;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -o-border-radius: 4px;
  border: 1px solid var(--as-product-border-color);
  aspect-ratio: 1;
  object-fit: cover;
  display: block;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -moz-box-sizing: border-box;
}
.header .product-card-body {
  font-style: normal;
  padding-top: 4px;
  padding-bottom: 0px;
  -webkit-padding-end: 0;
  padding-inline-end: 0;
  -webkit-padding-start: 12px;
  padding-inline-start: 12px;
  width: calc(100% - 32px - 44px - 35px);
  text-align: left;
}
.header .product-card-item-name {
    font-size: 18px;
    white-space: nowrap;
    width: calc(100%);
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 8px;
}

.overlay .header .heading {
  font-size: 18px;
    white-space: nowrap;
    width: calc(80%);
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 8px;
    display: inline-block;
}

.header .product-card-item-price {
  font-size: 18px;
  line-height: 20px;
  font-weight: 600;
  font-family: 'Helvetica Neue','Segoe UI',Helvetica,Arial,sans-serif;
}

.header .discount-price-container strike {
  color: var(--as-product-read-more-color);
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

.header .discount-price-container .percentoff {
  color: var(--as-discount-color);
  font-weight: 400;
  font-size: 16px;
}


.header .close-overlay {
  padding-left: 21px;
    padding-top: 21px;
    padding-right: 5px;
    cursor: pointer;
}

.sizeGuideWrapper .close-overlay {
  margin: 0;
  line-height: 20px;
  padding-top: 0px;
  float: right;
}

.sizeGuideWrapper{
  background: #fff;
  z-index: 1000000;
  position: absolute;
  height: 85vh;
  height: calc(var(--vh, 1vh) * 85);
  max-height: 620px;
  padding: 0px;
  top: 0px;
  display: none;
  text-align: left;
}
.sizeGuideVisible {
  display: block;
  width: 100%;
}

.sizeGuideWrapper img {
  width: 100%;
  max-height: calc(100% - 65px);
  margin-top: 65px;
  object-fit: contain;
}

.flexWrapper {
  box-sizing: border-box;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  position:absolute;
  width: 100%;
  top: 85px;
  text-align: left;
}

.vmWrapper {
  align-items: stretch;
  height: calc(85vh - 141px);
  height: calc(var(--vh, 1vh) * 85 - 141px);
  max-height: 479px;
  overflow-y: auto;
  overflow-x: hidden;
}

.ctaLinkContainer {
  flex-grow: 0;
  flex-shrink: 0;
  margin: 0;
  padding: 4px 0px 0px;
  z-index: 10000;
  position: relative;
  height: 48px;
} 

.ctaLink {
  display: inline-block;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  text-decoration: none;
  -webkit-text-decoration: none;
  width: 50%;
  overflow: hidden;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  z-index: 100;
  padding: 7px 8px;
  height: auto;
  font-size: 18px;
  font-weight: 600;
  line-height: 32px;
  vertical-align: middle;
  margin-bottom: 0px;
  height: 48px;
  overflow: hidden;
  /* box-shadow: 2px 7px 96px -2px rgba(255, 255, 255,0.5);
  -webkit-box-shadow: 2px 7px 96px -2px rgba(255, 255, 255,0.5);
  -moz-box-shadow: 2px 7px 96px -2px rgba(255, 255, 255,0.5); */
  background-color: var(--asplayer-btn-color);
  color: var(--asplayer-btn-txt-color);
  border: 1px solid var(--asplayer-btn-color);
}

.ctaLink:focus {
  color: var(--asplayer-btn-txt-color);
}

.ctaLink.outlinebtn {
  background-color: var(--asplayer-btn-txt-color);
  color: var(--asplayer-btn-color);
  border: 1px solid var(--asplayer-btn-color);
}

.ctaLink.outlinebtn:focus {
  color: var(--asplayer-btn-color);
}

.ctaLink.large {
  display: block;
}

.ctaLink.small {
  float: right;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 32px;
  height: 32px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 24px;
  height: 24px;
  margin: 4px;
  border: 4px solid #fff;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.toastMessage {
  background-color: rgba(0,0,0,0.7);
  color: #fff;
  display: inline-block;
  padding: 8px 16px;
  text-align: left;
  width: 100%;
  font-size: 14px;
  line-height: 1.2;
}

.productImages{
  padding: 12px 0px 20px 16px;
  width: 100%;
  height: calc(80vw);
  height: calc(var(--vw, 1vw) * 80);
  border-bottom: 1px solid var(--as-product-border-color);
  max-height: 320px;
  overflow: hidden;
}

.productImages.small{
  height: 144px;
}

.productImages .carousel-cell {
  margin-right: 12px;
  transition: 0.2s;
  visibility: visible;
  opacity: 1;
  position: absolute;
}

.productImages .carousel-cell.hidden {
  visibility: hidden;
  opacity: 0;
}

.productImages .carousel-cell.small {
  margin-right: 8px;
}

.productImages .carousel-cell {
  width: calc(80vw);
  height: calc(80vw);
  width: calc(var(--vw, 1vw) * 80);
  height: calc(var(--vw, 1vw) * 80);
  max-width: 320px;
  max-height: 320px;
}

.productImages .carousel-cell.small {
  width: 144px;
  height: 144px;
}

.productImages .carousel-cell img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* position dots in carousel */
.flickity-page-dots {
  bottom: 6px;
}
/* white circles */
.flickity-page-dots .flickity-page-dot {
  width: 6px;
  height: 6px;
  opacity: 1;
  background: var(--as-product-images-dot-color);
  margin: 0px 3px;
}
/* fill-in selected dot */
.flickity-page-dots .flickity-page-dot.is-selected {
  background: var(--as-product-images-selected-dot-color);
}

.border {
  border-bottom: 1px solid var(--as-product-border-color-separator);
}

.borderTop {
  border-top: 1px solid var(--as-product-border-color-separator);
}

.option {
  padding: 16px 8px;
  margin: 0px 8px;
}

.option.hasError .optionitems {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.option .label {
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: var(--as-product-section-heading-color);
  margin-bottom: 4px;
}

.option .guide {
  float: right;
  font-size: 14px;
  line-height: 16px;
  color: var(--as-product-section-heading-color);
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
}

.option .label .error {
  color: var(--as-error-color);
  font-weight: 400;
  font-size: 14px;
}
.option .optionitems {
  margin-left: -4px;
  margin-right: -4px;
}
.option .optionvalue {
  background-color: var(--as-product-options-background);
  border: 1px solid var(--as-product-options-border);
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  min-width: 40px;
  padding: 4px 6px;
  display: inline-block;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -moz-box-sizing: border-box;
  border-radius: 4px;
  margin: 4px 4px 4px 4px;
  cursor: pointer;
}
.option .optionvalue.circle {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -o-border-radius: 50%;
  width: 40px;
  height: 40px;
}
.option .optionvalue.selected {
  border: 2px solid var(--asplayer-btn-color);
  font-weight: 700;
  line-height: 28px;
}
.option .optionvalue.disabled {
  color: var(--as-product-options-disabled-color);
  background-image: linear-gradient(to top left,
  rgba(0,0,0,0) 0%,
  rgba(0,0,0,0) calc(50% - 0.8px),
  var(--as-product-options-disabled-color) 50%,
  rgba(0,0,0,0) calc(50% + 0.8px),
  rgba(0,0,0,0) 100%);
}

.container {
  padding: 16px 8px;
  margin: 0px 8px;
}

.productDetails .heading {
  line-height: 16px;
  font-size: 16px;
  font-weight: 500;
  color: var(--as-product-section-heading-color);
  margin-bottom: 12px;
}

.productDetails .description {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
}

.productDetails .readmore {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: var(--as-product-read-more-color);
}

/* The snackbar - position it at the bottom and in the middle of the screen */
#snackbar {
  visibility: hidden; /* Hidden by default. Visible on click */
  min-width: 250px; /* Set a default minimum width */
  margin-left: -125px; /* Divide value of min-width by 2 */
  background-color: #333; /* Black background color */
  color: #fff; /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 100000; /* Add a z-index if needed */
  left: 50%; /* Center the snackbar */
  bottom: 52px; /* 30px from the bottom */
}

/* Show the snackbar when clicking on a button (class added with JavaScript) */
#snackbar.show {
  visibility: visible; /* Show the snackbar */
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
  However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}